export default __webpack_public_path__ + "static/media/Ecommerce.99c19141.png";